import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  triggerMeetAutomateThunk,
} from "../slices/chat/thunk";
import { setIsMeetAgentModalOpen } from "../slices/chat/reducer";
import { MeetAgentSchema } from "validations/chat";
import * as yup from "yup";
import { useAuth } from "context/AuthContext";

const MeetModal = () => {
  const dispatch = useDispatch();
//   const { user } = useAuth();
  const { isMeetAgentModalOpen } = useSelector((state) => state.ChatReducer);

//   const [localUserId, setLocalUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState("");
  const [chatMessages, setChatMessages] = useState([
    {
      sender: "bot",
      content:
        "Hi! Please enter the start date, end date (or duration), and the title of the meeting you'd like to schedule.",
    },
  ]);
  const chatEndRef = useRef(null);

  const closeModal = () => {
    dispatch(setIsMeetAgentModalOpen(false));
    setChatMessages([
      {
        sender: "bot",
        content:
          "Hi! Please enter the start date, end date (or duration), and the title of the meeting you'd like to schedule.",
      },
    ]);
    setInput("");
  };

  const handleSend = async () => {
    const formData = { input };

    try {
      setLoading(true);

      const userMessage = { sender: "user", content: input };
      setChatMessages((prev) => [...prev, userMessage]);

      const meetResponse = await dispatch(
        triggerMeetAutomateThunk({
          chatInput: input,
        //   user_id: user?._id,
        })
      ).unwrap();

      const botMessage = {
        sender: "bot",
        content: meetResponse?.[0]?.output || "",
      };

      setChatMessages((prev) => [...prev, botMessage]);
      setInput("");

      if (meetResponse?.[0]?.meetScheduled) {
        setTimeout(() => {
          closeModal();
        }, 10000);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessages]);

//   useEffect(() => {
//     if (user?._id) {
//       setLocalUserId(user._id);
//     }
//   }, [user]);

  if (!isMeetAgentModalOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-[#0F172A] rounded-lg shadow-lg w-full max-w-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold">Schedule a Meeting</h2>
          <button onClick={closeModal} className="text-white text-xl">
            ×
          </button>
        </div>

        <div
          className="h-64 overflow-y-auto mb-4 border border-[#382F5C] 
hover:border-[#666699] focus:border-[#666699] active:border-[#666699] rounded p-3 bg-[#0B1723]"
        >
          {chatMessages.map((msg, idx) => (
            <div
              key={idx}
              className={`mb-2 p-2 rounded text-white ${
                msg.sender === "bot" ? "bg-[#1E293B]" : "bg-[#4C1D95]"
              }`}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: msg.content
                    .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
                    .replace(/\n/g, "<br>"),
                }}
              />
            </div>
          ))}
          <div ref={chatEndRef} />
        </div>

        <div className="flex items-center space-x-2 ">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type your response..."
            className="flex-grow rounded px-3 py-2  bg-[#0F172A] border border-[#382F5C] outline-none 
    hover:border-[#666699] focus:border-[#666699] active:border-[#666699]"
          />

          <button
            onClick={handleSend}
            disabled={loading}
            className={`px-4 py-2 rounded text-white transition 
    ${
      loading
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-violet-600 hover:bg-violet-700"
    }`}
          >
            {loading ? "Sending..." : "Send"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeetModal;
